<template>
  <div class="grid__layout">
    <section class="card--flex">
      <v-container grid-list-lg>
        <v-layout row>
          <v-flex
            :key="i"
            v-for="(item, i) in home.programmes"
            >
            <v-card
              dark
              ripple
              class="transparent elevation-4"
              flat
              :href="item.link"
              exact
              >
              <div>
                <v-img
                  :src="item.thumbnail"
                  alt=""
                  height="200"
                  width="280"
                  class="px-3"
                  @contextmenu.prevent="preventRightClick"
                  >
                  <v-layout
                    fill-height
                    justify-end
                    align-end
                    >
                    <v-btn
                      small
                      dark
                      color="secondary"
                      icon
                      >
                      <v-icon small>add</v-icon>
                    </v-btn>
                  </v-layout>
                </v-img>
              </div>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </section>
  </div>
</template>

<script>
import store from '@/store'
import Law from '@/modules/CDA/Home/assets/images/law.png'
import Act from '@/modules/CDA/Home/assets/images/act.png'
import Governance from '@/modules/CDA/Home/assets/images/governance.png'
import Strategic from '@/modules/CDA/Home/assets/images/strategic.png'
import Performance from '@/modules/CDA/Home/assets/images/performance.png'

export default {
  store,

  name: 'GridLayoutMobile',

  components: {
  },

  data () {
    return {
      home: {
        programmes: [
          {
            title: 'Cybersecurity Law & Cyber Terrorism',
            thumbnail: Law,
            link: '/programmes/cybersecurity-law-and-cyber-terrorism',
          },
          {
            title: 'Cybersecurity Act 2018 Compliance',
            thumbnail: Act,
            link: '/programmes/cybersecurity-act-2018-compliance',
          },
          {
            title: 'Cybersecurity Governance, Risk & Compliance',
            thumbnail: Governance,
            link: '/programmes/cybersecurity-governance-risk-and-compliance',
          },
          {
            title: 'Strategic Cybersecurity Risk Management',
            thumbnail: Strategic,
            link: '/programmes/strategic-cybersecurity-risk-management',
          },
          {
            title: 'Cybersecurity Performance Management',
            thumbnail: Performance,
            link: '/programmes/cybersecurity-performance-management',
          }
        ]
      }
    }
  },

  mounted () {
    this.preventRightClick()
  },

  methods: {
    preventRightClick () {
      return false
    }
  }
}
</script>
